import { generate } from '../index';
export default generate({
  env:  'production',
  path: {
    root: '/kaishi-chushi/'
  }
});
